import { render, staticRenderFns } from "./LanguagesTable.vue?vue&type=template&id=4dfc2d6f"
import script from "./LanguagesTable.vue?vue&type=script&lang=js"
export * from "./LanguagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports